import { useMutation, useQueryClient } from "@tanstack/react-query";

import { setFootprintingCropFertilizersOrganics, setFootprintingCropFertilizersOrganicsAdmin } from "services";

import { getEnvironment } from "utils";

import { FOOTPRINTING_CROP, FOOTPRINTING_CROP_FERTILIZERS_ORGANIC } from "consts";

import { FootprintingCropFertilizer } from "models";

export const useMutateFootprintingCropFertilizersOrganics = (
  farmId: string,
  cropId: string,
  year: number,
  payload: FootprintingCropFertilizer[],
  primaryDataId: string
) => {
  const queryClient = useQueryClient();
  const isAdmin = getEnvironment().admin;

  const queryFn = isAdmin ? setFootprintingCropFertilizersOrganicsAdmin : setFootprintingCropFertilizersOrganics;

  return useMutation(
    {
      mutationKey: [FOOTPRINTING_CROP_FERTILIZERS_ORGANIC, primaryDataId],
      mutationFn: () => queryFn(payload, primaryDataId),
      onSuccess: async () => {
        const QKs = [
          [FOOTPRINTING_CROP_FERTILIZERS_ORGANIC, primaryDataId],
          [FOOTPRINTING_CROP, farmId, cropId, year],
          [FOOTPRINTING_CROP, primaryDataId, isAdmin],
        ];
        await Promise.all(QKs.map((QK) => queryClient.invalidateQueries({ queryKey: QK })));
        await Promise.all(QKs.map((QK) => queryClient.refetchQueries({ queryKey: QK })));
      },
    },
    queryClient
  );
};
